const Ajax = {
	filter: {
		count: () => {
			let page = {};
			page.filter	= $('.filter');

			if (! page.filter.length) return;

			page.count = {};
			page.count.submit = page.filter.find('button[type="submit"]');
			page.count.button = $('#result-count');

			var data = page.filter.serialize();

			$.ajax({
				type: 'POST',
				url: '/api/filter/count',
				data: data,
				beforeSend: () => {},
				success: html => {
					// if (number > 0) {
						page.count.submit.after(html).remove();
						// page.count.button.children('span').text(number);
						// page.count.button.addClass('shown');
					// } else {

					// }
				},
			});
		}
	}
}

export default Ajax